'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = VisualPickerOptionFooter;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * A VisualPickerOptionFooter.
 * @category Form
 */


function VisualPickerOptionFooter(props) {
  var label = props.label,
      description = props.description,
      className = props.className,
      style = props.style;

  var getContainerClassName = function getContainerClassName() {
    return (0, _classnames2.default)('rainbow-visual-picker-option-footer_container', className);
  };

  return _react2.default.createElement('article', {
    className: getContainerClassName(),
    style: style
  }, _react2.default.createElement('h1', {
    className: 'rainbow-visual-picker-option-footer_label'
  }, label), _react2.default.createElement('h2', {
    className: 'rainbow-visual-picker-option-footer_description'
  }, description));
}

VisualPickerOptionFooter.propTypes = {
  /** The label displayed for the VisualPickerOptionFooter. */
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),

  /** The description displayed for the VisualPickerOptionFooter. */
  description: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),

  /** The class name of the root element. */
  className: _propTypes2.default.string,

  /** It is an object with custom style applied to the root element. */
  style: _propTypes2.default.object
};
VisualPickerOptionFooter.defaultProps = {
  label: '',
  description: '',
  className: undefined,
  style: undefined
};